import type { CSSProperties, ReactNode } from 'react';

import { Descriptions } from '@arco-design/web-react';

import { StorageClassDisplay } from '@/delivery-type-plugin/components/storageClassDisplay';

import type { DisplayDescriptor } from './types';

export interface DescriptorDescriptionsProps {
  items: DisplayDescriptor[];
  column?: number;
  style?: CSSProperties;
  className?: string;
  /** 可选标签渲染；未传时维持原有仅展示 value 的行为。 */
  tagRender?: (tag: string, item: DisplayDescriptor) => ReactNode;
}

/** ResourcePreview 只读展示：与应用实例确认页一致的 Descriptions 边框样式 */
export function DescriptorDescriptions({ items, column = 1, style, className, tagRender }: DescriptorDescriptionsProps) {
  if (!items.length) {
    return null;
  }

  const data = items.map((item) => ({
    label: item.label,
    value: item.storageClassInfo ? (
      <StorageClassDisplay {...item.storageClassInfo} />
    ) : item.tag && tagRender ? (
      <span style={{ display: 'inline-flex', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
        <span>{item.value || '-'}</span>
        {tagRender(item.tag, item)}
      </span>
    ) : (
      item.value || '-'
    ),
  }));

  return <Descriptions className={className} column={column} data={data} border style={style} />;
}
